"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

var _react = _interopRequireDefault(require("react"));

require("../activity.scss");

const CategoryOption = props => {
  const {
    disabled,
    option,
    onTextChange
  } = props;
  const {
    text
  } = option;
  return /*#__PURE__*/_react.default.createElement(_input.default, {
    spellCheck: true,
    disabled: disabled,
    placeholder: "Option text",
    value: text,
    onChange: onTextChange,
    style: {
      width: '100%'
    }
  });
};

var _default = CategoryOption;
exports.default = _default;